import createIsDirty from './selectors/isDirty';
import plain from './structure/plain';

export default createIsDirty(plain);


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/isDirty.js
// module id = 592
// module chunks = 0